<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )

    receipt(ref="receipt")
</template>

<script>
const TableName = 'VUETABLE_TRANSACTION';
import receiptMixin from '../../mixins/receipt';

export default {
    mixins: [receiptMixin],

    data: function() {
        var that = this;

        return {
            transaction: null,
            tableName: TableName,
            columns: [
                'settled_date',
                'sequence_number',
                'cashier',
                'outlet_name',
                'table_name',
                'pax',
                'customer',
                'total_amount',
                'payment_name',
            ],
            options: {
                texts: {
                    title: 'All Transaction',
                    description: 'Shows transaction details',
                },

                customFilters: ['outlet_id', 'since', 'until'],
                useReportFilter: true,
                columnsDropdown: true,

                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },

                headings: {
                    settled_date: 'Receipt Date',
                    sequence_number: 'Receipt No.',
                    payment_name: 'Payment',
                    table_name: 'Table',
                    outlet_name: 'Outlet',
                    total_amount: 'Grand Total',
                },

                orderBy: {
                    column: 'settled_date',
                    ascending: 0,
                },

                templates: {
                    pax(h, row) {
                        return row.pax === null ? 'N/A' : row.pax;
                    },

                    table_name(h, row) {
                        return row.table_name === null
                            ? 'Takeaway'
                            : row.table_name;
                    },

                    sequence_number: (h, row) => {
                        return this.receiptNumberFormat(row);
                    },

                    settled_date: (h, row) => {
                        return this.receiptDateFormat(row.settled_date);
                    },
                    total_amount: (h, row) => {
                        return numeral(parseFloat(row.total_amount)).format();
                    },
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: row => {
                    this.showReceipt(row.id);
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.report.transaction.all');
        },
    },
    methods: {
        showReceipt(transaction_id) {
            this.$refs.receipt.$emit('show-receipt', transaction_id);
        },
        downloadExportDetails(type) {
            let url = Laroute.route(
                'franchise.report.transaction.exportAsFile',
                { type },
            );

            window.open(
                `${url}?${this.$refs.datatable.getQueryParams() +
                    '&details=true'}`,
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/vuetable_all_transaction.vue